<template>
    <transition name="slide">
        <div class="modal fade" ref="modalContainer" @keyup.enter="CONFIRM()" tabindex="-1" role="dialog" :class="onalert ? 'show' : 'show'" :style="onalert ? 'display: block; padding-left: 0px;' : ''">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content shadow-3">
                    <div class="modal-header">
                        <div class="icon icon-shape rounded-3 bg-soft-danger text-danger text-lg me-4">
                            <i class="bi bi-info-circle-fill"></i>
                        </div>
                        <div>
                            <h5 class="mb-1">¿Realmente desea continuar?</h5>
                            <small class="d-block text-xs text-muted">
                                <div v-html="alert"></div>
                            </small>
                        </div>
                        <div class="ms-auto">
                        </div>
                    </div>
                    <form class="modal-footer" @submit.prevent="CONFIRM()">
                        <button type="submit" ref="btn" class="btn btn-h btn-danger px-3">
                            <div class="spinner-border spinner-border-sm" role="status" v-if="count == 1">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <span v-else>Si</span>
                        </button>
                        <button type="button" class="btn btn-h btn-dark px-3" @click="$emit('onclose')">No</button>
                    </form>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
export default{
    props: ['onalert', 'number', 'alert', 'count'],
    data(){
        return{
            password: '',
            type: false
        }
    },
    created(){
        let vue = this
        vue.$nextTick(() => vue.$refs.modalContainer.focus())
    },
    methods: {
        CONFIRM: function(){
            this.$emit('confirm', this.number)
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/delivery-routes/modals/Alert.vue